// cordova-advanced-http, version 1.11.1
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TransportError } from './Transport';
export const AdvancedHttpRequest = {
    acceptAllCerts: (accept) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise(resolve => {
            cordova.plugin.http.acceptAllCerts(accept, resolve, () => new Error('acceptAllCerts failed'));
        });
    }),
    sendRequest: (req) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const url = `${req.scheme}://${req.host}${req.path}`;
        const options = {
            method: req.method,
        };
        if (req.data !== undefined)
            options.data = req.data;
        if (req.headers !== undefined)
            options.headers = req.headers;
        if (req.params !== undefined)
            options.params = req.params;
        if (req.serializer !== undefined)
            options.serializer = req.serializer;
        if (req.timeout !== undefined)
            options.timeout = req.timeout;
        // This is a workaround for cordova-plugin-advanced-http. It only
        // supports Object and Array types for the data option when using the
        // json serializer. However, it is valid to also send simple types
        // (e.g., boolean). This workaround tricks the plugin by changing the
        // serializer to utf8, but overriding the Content-Type header from
        // application/text to application/json.
        if ((options === null || options === void 0 ? void 0 : options.serializer) === 'json' &&
            options.data !== undefined &&
            typeof options.data !== 'object') {
            options.serializer = 'utf8';
            if (!options.headers)
                options.headers = {};
            options.headers['Content-Type'] = 'application/json';
            options.data = options.data.toString();
        }
        const resp = yield new Promise(resolve => {
            cordova.plugin.http.sendRequest(url, options, resolve, resp => {
                resolve(resp);
            });
        });
        if (resp.status === 1 && resp.error === 'The request timed out') {
            throw new TransportError('http request timeout', 'sendTimeout');
        }
        else if (resp.status === -1 && ((_a = resp.error) === null || _a === void 0 ? void 0 : _a.includes('Failed to connect'))) {
            throw new TransportError(resp.error, 'cantSend');
        }
        return resp;
    }),
};
